import React from "react";
import styled from "styled-components";
import { Device } from "../../../components/device";
import Anchor from "../../../components/Router/Anchor";
import { Link } from "../../../typings/typings";

interface StickySubMenuProps
{
    header: string;
    menuItems: Link[];
}

const StickySubmenuWrap = styled.nav`
    position: relative;
    padding: 1.5rem;
    background-color: #f4f4f4;
    color: #2e2e2e;
    line-height: 1.5;
    ${Device.laptop} {
        padding: 2.5rem;
    }
    .sticky-submenu__header {
        font-size: var(--text-lg, 1.125rem);
        font-weight: bold;
        line-height: var(--leading-tight, 1.25);
        margin-bottom: 1rem;
        text-transform: uppercase;
        ${Device.laptop} {
            font-size: var(--text-lg, 1.133rem);
        }
    }
    ul {
        column-count: 2;
        column-gap: 1rem;
        font-size: 14px;
        line-height: 1.25;

        ${Device.laptop} {
            column-gap: 2.5rem;
            padding-right: 20%;
        }
    }
    a,button {
        display: inline-block;
        margin-bottom: .5rem;
        position: relative;
        opacity: .66;
        font-weight: 500;
        word-break: break-word;
        &:after {
            content:"";
            height: 1px;
            width: 100%;
            background-color: currentColor;
            position: absolute;
            left: 0;
            bottom: 0;
            max-width: 0;
            transition: max-width .15s, opacity .15s;
        }
        &:hover,
        &:focus,
        &:active,
        &.active  {
            opacity: 1;
            &:after {
                max-width: 100%;
            }
        }
    }
    .sticky-submenu__btn
    {
        position: absolute;
        right: 1rem;
        top: 1rem;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid currentColor;
        transform: rotate(130deg);
        opacity: 75;
        display: none; //temp
        &:focus {
            outline: none;
        }
        ${Device.laptop} {
            right: 1.25rem;
            top: 1.25rem;
            border-top: 9px solid transparent;
            border-bottom: 9px solid transparent;
            border-right: 9px solid currentColor;
        }
    }
`;

const StickySubMenu: React.FC<StickySubMenuProps> = (props) =>
{
    const { menuItems } = props;
    const getMenuItems = () =>
    {
        return menuItems?.map((link, i) =>
        {
            let url;
            // if the url is empty in Umbraco, it will be the same as the queryString
            if (link.url && link.url !== link.queryString)
            {
                url = link.url;
            }
            else
            {
                const queryString = link.queryString || "";
                const prefix = link.route?.path || "";
                url = prefix + queryString;
            }
            return <li key={i}><Anchor to={url} target={link.target}>{link.title || link.name}</Anchor></li>;
        });
    };

    return (
        <StickySubmenuWrap>
            <h3 className="sticky-submenu__header tracking-wider mb-4 lg:mb-6">{props.header}</h3>
            <ul>
                {getMenuItems()}
            </ul>
            <button className="sticky-submenu__btn" />
        </StickySubmenuWrap>
    );
};

export default StickySubMenu;